export { default } from './FeaturedProducts';
